angular
  .module("tcMailgun")
  .factory("tcMailgunPersistance", tcMailgunPersistance);

function tcMailgunPersistance($q, tcMailgun) {
  var unwrapResponse = R.prop("data");

  function validate(email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return $q
      .resolve({
        data: {
          address: email,
          did_you_mean: null,
          is_valid: re.test(String(email).toLowerCase()),
        },
      })
      .then(unwrapResponse);
  }

  return {
    validate: validate,
  };
}
